// extracted by mini-css-extract-plugin
export var actionText = "_r1-4";
export var container = "_r1-0";
export var leftSection = "_r1-1";
export var rightSection = "_r1-2";
export var settingsButton = "_r1-6";
export var settingsIcon = "_r1-7";
export var shortcut = "_r1-5";
export var shortcutGroup = "_r1-3";